export default "/images/PersonalCareProducts.webp?23654d8ce59022cf039447d702908408";